import { VpMaskMethods } from '@ps/bridge/qc/vp/mask'
const VpCategories = {
  mask: 'Mask Component',
}
export default {
  maskAction: {
    [VpMaskMethods.vpEnableMaskComponent]: {
      label: 'Enable/Disable Mask Component',
      category: VpCategories.mask,
      paramFormConfig: {
        isEnable: {
          title: 'Enable/Disable',
          field: {
            options: [
              {
                label: 'Enable',
              },
              {
                label: 'Disable',
              },
            ],
          },
        },
      },
    },
    [VpMaskMethods.vpEnableMaskGroupComponent]: {
      label: 'Enable/Disable Mask Groups',
      category: VpCategories.mask,
      paramFormConfig: {
        actionGroup: {
          title: 'Responsive Object',
          component: 'select',
          field: {
            options: [],
          },
        },
        isEnable: {
          title: 'Enable/Disable',
          component: 'select',
          field: {
            options: [
              {
                label: 'Enable',
                value: true,
              },
              {
                label: 'Disable',
                value: false,
              },
            ],
          },
        },
      },
    },
    [VpMaskMethods.vpShowMaskGroup]: {
      label: 'Show/Hide Mask Groups',
      category: VpCategories.mask,
      paramFormConfig: {
        actionGroup: {
          title: 'Responsive Object',
          component: 'select',
          field: {
            options: [],
          },
        },
        isShow: {
          title: 'Show/Hide',
          component: 'select',
          field: {
            options: [
              {
                label: 'Show',
                value: true,
              },
              {
                label: 'Hide',
                value: false,
              },
            ],
          },
        },
      },
    },
    [VpMaskMethods.vpShowMaskSubGroup]: {
      label: 'Show/Hide Groups',
      category: VpCategories.mask,
      paramFormConfig: {
        actionGroup: {
          title: 'Responsive Object',
          component: 'select',
          field: {
            options: [],
          },
        },
        isShow: {
          title: 'Show/Hide',
          component: 'select',
          field: {
            options: [
              {
                label: 'Show',
                value: true,
              },
              {
                label: 'Hide',
                value: false,
              },
            ],
          },
        },
      },
    },
    [VpMaskMethods.vpEnableMaskShape]: {
      label: 'Show/Hide Mask Effect',
      category: VpCategories.mask,
      paramFormConfig: {
        actionGroup: {
          title: 'Responsive Object',
          component: 'select',
          field: {
            options: [],
          },
        },
        isEnable: {
          title: 'Enable/Disable',
          component: 'select',
          field: {
            options: [
              {
                label: 'Enable',
                value: true,
              },
              {
                label: 'Disable',
                value: false,
              },
            ],
          },
        },
      },
    },
  },
}
